export default "/images/vendor/quill/icons/bold.svg?7781b6114a3fb65a98f0b178c0d67578";